const locale = {
	INITIALIZATION_TITLE: 'Initialization',
	enter_project_branch: 'Enter Project Branch',
	enter_project_type: 'Enter Project Type',
	enter_group_type:'Enter Group Type',
	enter_user_position:'Enter User Position',
	edit_details: 'Edit Details',
	active:'Active',
	inactive:'Inactive',
	unverified: 'Unverified',
	deleted: 'Deleted',
	submit:'Submit',
	export: 'Export',
	cancel:'Cancel',
	update:'Update',
	delete:'Remove',
	recover:'Recover',
	companies:'Companies',
	search:'Search',
	filter:'Filter',
	filter_by:'Filter By:',
	reset_filters:'Reset Filters',
	status:'Status',
	actions:'Actions',
	initialization:'Initialization',
	project_branch: 'Project Branch',
	project_type: 'Project Type',
	group_type: 'Group Type',
	user_position: 'User Position',
	add_project_branch: 'Add Project Branch',
	add_project_type: 'Add Project Type',
	add_group_type: 'Add Group Type',
	add_user_position: 'Add User Position',
	edit_project_branch: 'Edit Project Branch',
	edit_project_type: 'Edit Project Type',
	edit_group_type: 'Edit Group Type',
	edit_user_position: 'Edit User Position',
	if_you_want_to_give_a_specific_name_for_this_position:'If you want to give a specific name for this position',
	do_you_want_to_remove_this_project_branch : 'Do you want to remove this Project Branch ?',
	do_you_want_to_remove_this_project_type : 'Do you want to remove this Project Type ?',
	do_you_want_to_remove_this_group_type : 'Do you want to remove this Group Type ?',
	do_you_want_to_remove_this_user_position : 'Do you want to remove this User Position ?',
	do_you_want_to_recover_this_project_branch : 'Do you want to recover this Project Branch ?',
	do_you_want_to_recover_this_project_type : 'Do you want to recover this Project Type ?',
	do_you_want_to_recover_this_group_type : 'Do you want to recover this Group Type ?',
	do_you_want_to_recover_this_user_position : 'Do you want to recover this User Position ?',
	no : 'No',
	enter_position_local_name:'Enter position local name',
	this_name_already_exist:'This name already exist!',

	project_branch_local_name: 'Project Branch local name',
	project_type_local_name: 'Project Type local name',
	group_type_local_name: 'Group Type local name',
	user_position_local_name: 'User Position local name',
	local_name: 'Local Name',
	created_succesfully:'Created Succesfully',
	updated_succesfully: 'Updated Succesfully',
	something_went_wrong : 'Something went wrong!',
};

export default locale;
